import {Pill} from '@wandb/components';
import React from 'react';

type FoundPanelsPillProps = {
  isInScope: boolean; // scope may be global or a specific section
};

export const FoundPanelsPill = ({isInScope}: FoundPanelsPillProps) => {
  const tooltipText = `This key has already been added${isInScope ? '.' : ' (in another section).'}`;
  return (
    <Pill
      icon="checkmark2"
      textValue="Added"
      color={isInScope ? 'green' : 'moon'}
      tooltip={{children: tooltipText}}
    />
  );
};
